import React from 'react';
import Image from '~/components/Image';
import ECD from '~/public/static/landings/ecd2020/ecd.png';
import PERANIS from '~/public/static/landings/peranis/peranis.jpg';
import {
  ECD2020_EVENT_CODE,
  PERANIS2020_EVENT_CODE,
} from '../../constants/referralCodes';

interface Props {
  referralCode?: string;
}

const ReferralCodeGuidance: React.FC<Props> = ({ referralCode }) => {
  if (!referralCode) {
    return null;
  }

  if (/^perani'?s$/i.test(referralCode)) {
    return (
      <div className="bg-grey-300 mx-auto mb-4 w-full rounded-sm border border-black p-4">
        <div className="flex space-x-4">
          <div className="flex-shrink-0">
            <Image src={PERANIS} className="h-10 w-10" />
          </div>

          <div className="text-base font-bold">
            Welcome to the Perani&apos;s Resale Event
          </div>
        </div>

        <p className="mb-0 mt-4 text-xs text-black">
          Earn an <b>extra 15% bonus</b> on your resale value when you use
          referral code &ldquo;{PERANIS2020_EVENT_CODE}
          &rdquo; at sign up. All sales will be converted to a Perani&apos;s
          shopping credit.
        </p>
      </div>
    );
  }

  if (/^ecd2020$/i.test(referralCode)) {
    return (
      <div className="bg-grey-300 mx-auto mb-4 w-full rounded-sm border border-black p-4">
        <div className="flex space-x-4">
          <div className="flex-shrink-0">
            <Image src={ECD} className="h-10 w-10" />
          </div>

          <div className="text-base font-bold">
            Welcome to the ECD 2021 Resale Event
          </div>
        </div>

        <p className="mb-0 mt-4 text-xs text-black">
          Earn an <b>extra 15% bonus</b> on your resale value when you use
          referral code &ldquo;{ECD2020_EVENT_CODE}
          &rdquo; at sign up. All sales will be converted to an ECD shopping
          credit.
        </p>
      </div>
    );
  }

  return null;
};

export default ReferralCodeGuidance;
